"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasLoginInfoUpdateCapability = exports.getUserNotice = exports.getUserCapabilities = exports.getIsUCIenabled = exports.validMomentBirthdate = exports.userLoaded = exports.getIsLabRat = exports.getReceivesNewLetter = exports.getUserId = exports.getUserEmail = exports.getUser = exports.hasTeams = exports.user = void 0;
exports.ageGroup = ageGroup;
const utils_1 = require("core/utils");
const user = (state) => state.user;
exports.user = user;
const hasTeams = (state) => (0, exports.user)(state).hasTeams;
exports.hasTeams = hasTeams;
const getUser = (state) => (0, exports.user)(state).user;
exports.getUser = getUser;
const getUserEmail = (state) => (0, exports.getUser)(state).email;
exports.getUserEmail = getUserEmail;
const getUserId = (state) => (0, exports.getUser)(state).id;
exports.getUserId = getUserId;
const getReceivesNewLetter = (state) => (0, exports.getUser)(state).receivesNewsletter;
exports.getReceivesNewLetter = getReceivesNewLetter;
const getIsLabRat = (state) => (0, exports.getUser)(state).isLabRat;
exports.getIsLabRat = getIsLabRat;
const userLoaded = (state) => (0, exports.user)(state).userLoaded;
exports.userLoaded = userLoaded;
const validMomentBirthdate = (birthdate) => birthdate && (0, utils_1.parseDate)(birthdate);
exports.validMomentBirthdate = validMomentBirthdate;
function ageGroup(birthdate) {
    if (!birthdate) {
        return 'Adult';
    }
    const age = (0, utils_1.todayMoment)().diff((0, exports.validMomentBirthdate)(birthdate), 'years');
    if (age < 13) {
        return 'Child';
    }
    else if (age < 18) {
        return 'Teen';
    }
    return 'Adult';
}
const getIsUCIenabled = (state) => {
    const email = (0, exports.user)(state).user?.email || '';
    // include internal emails in rollout, but not cypress yet
    // return email.includes("@teamsnap.com") && !email.includes("automation");
    return [].includes(email); // add any emails for debugging
};
exports.getIsUCIenabled = getIsUCIenabled;
const getUserCapabilities = (state) => (0, exports.getUser)(state).capabilities ?? [];
exports.getUserCapabilities = getUserCapabilities;
const getUserNotice = (state) => (0, exports.getUser)(state).notice;
exports.getUserNotice = getUserNotice;
const hasLoginInfoUpdateCapability = (state) => (0, exports.getUserCapabilities)(state).includes('login_info:update');
exports.hasLoginInfoUpdateCapability = hasLoginInfoUpdateCapability;
